import  LimitationTypes from './types';

/** ****************************
 * Fetch limitation
 ***************************** */

export const fetchlimitations = (orgId) => ({
  type: LimitationTypes.FETCH_LIMITATION_START,
  data: {orgId} ,
});


export const fetchlimitationSuccess = (limitation) => ({
    type: LimitationTypes.FETCH_LIMITATION_SUCCESS,
    payload: limitation
  });
  export const fetchlimitationFailure = (error) => ({
    type: LimitationTypes.FETCH_LIMITATION_FAILURE,
    error,
  });

  export const fetchPlanConfigStart = (orgId) => ({
    type: LimitationTypes.FETCH_PLANCONFIG_START,
    data: {orgId} ,
  });
  
  
  export const fetchPlanConfigSuccess = (limitation) => ({
      type: LimitationTypes.FETCH_PLANCONFIG_SUCCESS,
      payload: limitation
    });
    export const fetchPlanConfigFailure = (error) => ({
      type: LimitationTypes.FETCH_PLANCONFIG_FAILURE,
      error,
    });
  

/** ****************************
 * Reset state
 ***************************** */
export const resetState = () => ({
  type: LimitationTypes.RESET_STATE,
});
